// @flow
import * as React from 'react';

// Components
import AppRouter from './AppRouter';
import { withEasterEgg } from 'components/common/decorators/easterEgg/EasterEgg';

const App = () => {
  return <AppRouter key="router" />;
};

export default withEasterEgg(App);



// WEBPACK FOOTER //
// ./src/components/statusTracker/App.js